import React from 'react';
import PropTypes from 'prop-types';
import { statuses, startChat } from '../index';
import { StyledButton } from './styles';

const WebchatCta = ({ config, icon, heading, status, insideSideBar }) => {
  let statusText;

  if (status === statuses.LOADING) {
    statusText = config[`statusDescription${status}`];
  } else if (status === statuses.BANK_HOLIDAY) {
    statusText = config[`webchatCta${statuses.OFFLINE}`];
  } else {
    statusText = config[`webchatCta${status}`];
  }

  return (
    <StyledButton
      bg="secondary-standard"
      disabled={status !== statuses.ONLINE}
      onClick={() => startChat()}
      heading={heading}
      icon={icon}
      iconPlacement="left"
      size="xxl"
      fullWidth={insideSideBar}
      $insideSideBar={insideSideBar}
      $status={status}
    >
      {statusText}
    </StyledButton>
  );
};

WebchatCta.propTypes = {
  icon: PropTypes.string,
  heading: PropTypes.string,
  status: PropTypes.oneOf(Object.values(statuses)),
  config: PropTypes.object,
  insideSideBar: PropTypes.bool,
};

export default WebchatCta;
